import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatIcon } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreService } from '../../../../services/core.service';
import { SectionGridComponent } from '../../components/section-grid/section-grid.component';

@Component({
  selector: 'app-index-company',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIcon, MatTooltipModule, SectionGridComponent],
  templateUrl: './index-company.component.html',
  styleUrl: './index-company.component.scss'
})
export class IndexCompanyComponent implements OnInit {

  companyInfo: any = null;
  companyID: number = 0;
  filtered: number | null = null;
  showPostsModal: boolean = false;
  initialDate: Date | null = null;

  // Add date range properties
  startDate: string = '';
  endDate: string = '';

  isFirstLoad: boolean = true;

  constructor(
    private coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.companyID = params['company'];
    });
    this.loadCompanyInfo();
    // this.initializeDates();
  }

  loadCompanyInfo(filteredParam?: number | null, startDate?: string, endDate?: string) {
    if (filteredParam !== undefined) {
      this.filtered = filteredParam;
    }

    const params: any = { company_id: this.companyID };

    if (this.filtered !== null) {
      params.filtered = this.filtered;
    }

    if (startDate && endDate) {
      params.start_date = startDate;
      params.end_date = endDate;
      this.filtered = null;
    } else if (this.startDate && this.endDate) {
      // Use currently selected dates
      params.start_date = this.startDate;
      params.end_date = this.endDate;
      this.filtered = null;
    }

    this.coreService.getData('/manageAccount/company/info/index', params)
      .subscribe({
        next: (response) => {
          this.companyInfo = response.data || response;
          console.log(this.companyInfo);
          if (this.isFirstLoad) {
            this.initializeDates();
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
  }

  openPostsModal(): void {
    this.showPostsModal = true;
    document.body.style.overflow = 'hidden';
  }

  closePostsModal(): void {
    this.showPostsModal = false;
    document.body.style.overflow = 'auto';
  }

  initializeDates(forceReset: boolean = false): void {
    const today = new Date();


    if (this.isFirstLoad || forceReset) {
      // Default to 30 days ago
      let startDate = new Date();
      startDate.setDate(today.getDate() - 30);

      // Use begins_at if available and filtered is null
      if (this.filtered === null && this.companyInfo?.company?.begins_at) {
        const beginsAtDate = new Date(this.companyInfo.company.begins_at.replace(' ', 'T'));

        if (!isNaN(beginsAtDate.getTime())) {
          startDate = beginsAtDate;
        }
      }

      this.endDate = this.formatDate(today);
      this.startDate = this.formatDate(startDate);

      // Mark first load as complete
      if (this.isFirstLoad) {
        this.isFirstLoad = false;
      }
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onDateChange(): void {
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);

      if (end < start) {
        this.endDate = this.startDate;
      }
    }
  }

  setDateRange(days: number): void {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - days);

    // Update the selected dates
    this.startDate = this.formatDate(startDate);
    this.endDate = this.formatDate(today);
    this.onDateChange();

    // Load data with the new date range
    this.loadCompanyInfo(days, this.startDate, this.endDate);
  }

  setThisMonth(): void {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.startDate = this.formatDate(firstDay);
    this.endDate = this.formatDate(lastDay);
  }

  setLastMonth(): void {
    const today = new Date();
    const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

    this.startDate = this.formatDate(firstDayLastMonth);
    this.endDate = this.formatDate(lastDayLastMonth);
  }

  calculateDaysBetween(): number {
    if (!this.startDate || !this.endDate) return 0;

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    const timeDiff = Math.abs(end.getTime() - start.getTime());
    return Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;
  }

  applyDateRange(): void {
    if (!this.startDate || !this.endDate) {
      alert('Please select both start and end dates');
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (end < start) {
      alert('End date cannot be before start date');
      return;
    }

    // Calculate days difference
    const daysDiff = this.calculateDaysBetween();

    // Send request with user's selected dates
    this.loadCompanyInfo(daysDiff, this.startDate, this.endDate);

    // Close the modal
    this.closePostsModal();
  }

  resetDates(): void {
    // Force reset to initial dates
    this.initializeDates(true);

    // Optionally reload data with reset dates
    this.loadCompanyInfo();
  }
}
